import { useState, useEffect, useCallback } from "react";
import axiosInstance from "services/httpInterceptor";

/**
 * Auto-triggering hook for inline briefing content.
 * Fires on mount and whenever `params` changes (by JSON equality).
 * Designed to replace the modal-triggered useQuickCatchupData pattern
 * for pages where the briefing is always-visible, not opt-in.
 */
const useInlineBriefingData = (endpoint, params = {}) => {
  const [briefing, setBriefing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const paramsKey = JSON.stringify(params);

  const fetchData = useCallback(async () => {
    if (!endpoint) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setBriefing(null);

    try {
      const response = await axiosInstance.get(endpoint, { params });
      setBriefing(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, paramsKey]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { briefing, loading, error, refetch: fetchData };
};

export default useInlineBriefingData;
